<div class="modal active">
  <div class="modal__container" style="width: 15%;">
    <div class="fields">
      <h2 class="title">Color</h2>
        <div class="close" (click)="this.bsModalRef.hide()"><img src="/assets/img/close-white.svg" alt="" /></div>
        <div class="fields__container">
          <div class="fields__block">
            <div class="fields__block__section">
              <label for="coverageColor">Coverage Color</label>
              <input type="color" class="input-color" name="coverageColor" [(ngModel)]="coverageColor">
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" class="blue" (click)="ok()">
              Ok
            </button>
            <button class="gray" (click)="this.bsModalRef.hide()">
              Cancel
            </button>
          </div>
        </div>
    </div>
  </div>
</div>
